import type { AnimationConfig } from "svelte/animate";
import { prefersReducedMotion } from "svelte/motion";
import type { TransitionConfig } from "svelte/transition";

export function createReduced<TArgs extends unknown[]>(
	fn: (node: Element, ...args: TArgs) => AnimationConfig,
): (node: Element, ...args: TArgs) => AnimationConfig;
export function createReduced<TArgs extends unknown[]>(
	fn: (node: Element, ...args: TArgs) => TransitionConfig,
): (node: Element, ...args: TArgs) => TransitionConfig;
export function createReduced<TArgs extends unknown[]>(
	fn: (node: Element, ...args: TArgs) => AnimationConfig | TransitionConfig,
): (node: Element, ...args: TArgs) => AnimationConfig | TransitionConfig {
	return function reduced(...args) {
		return prefersReducedMotion.current ? {} : fn(...args);
	};
}
